import { api } from 'app/config/apiConfig';
import { RentOptionDocument } from '../model/types';

export const updateRentOptionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateRentOption: builder.mutation<RentOptionDocument, Partial<RentOptionDocument>>({
      query: (rentOption: RentOptionDocument) => ({
        url: `/contracts/rent/rent-options/${rentOption.rentOptionId}`,
        method: 'PUT',
        body: rentOption,
      }),
      invalidatesTags: ['Rent options'],
    }),
  }),
});

export const { useUpdateRentOptionMutation } = updateRentOptionApi;
